import { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useAppDispatch } from '../redux/store';
import {
  postLoungeCommentReply,
  fetchStickerLounges,
  addSticker,
  likeCommentReply,
} from '../redux/lounges/slice';
import stickerImage from '../assets/img/stickers.jpg';
import { StickerTabs } from '../components/StickerTabs';
import { selectLounges } from '../redux/lounges/selectors';

import imageicon from '../assets/img/chart-icon1.png';
import emojiicon from '../assets/img/chart-icon2.png';
import { RichTextEditor } from '@mantine/rte';
import imageiconh from '../assets/img/chart-icon1h.png';
import emojiiconh from '../assets/img/chart-icon2h.png';
import { EditBox } from '../components/EditBox';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { removeUserLoungeWdw } from '../redux/lounges/slice';
import { LikeCommentReply } from '../components/LikeCommentReply';
import { GET_BASE_URL_IMAGE } from '../constants/apiEndpoints';
import axios, { AxiosResponse } from 'axios';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { getUserMembershipBadges } from '../utils/userMembershipBadges';
import { getMouseWaitUserAvatarUrl } from '../utils/avatar';


type CommentReplyBoxPropsType = {
  replyData: any;
  stickerData: any;
  onReplyToParent?: (
    targetUserName?: string,
    targetReplyId?: any,
    targetReplyText?: string
  ) => void;
  replyComposer?: any;
};
type FormData = {
  chat_reply_msg: string;
  chat_id: number;
  chat_reply_id: number;
};

export const CommentReplyBox: React.FC<CommentReplyBoxPropsType> = ({
  replyData,
  stickerData,
  onReplyToParent,
  replyComposer
}) => {
  const {
    register,
    setValue,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm<FormData>();
  const dispatch = useAppDispatch();
  const { stickerPickItems, items } = useSelector(selectLounges);

  const [commentData, SetCommentData] = useState<any | []>(replyData);
  const [showSticker, SetShowSticker] = useState<any | string>(false);
  const [stickerSelection, SetStickerSelection] = useState<any | string>(null);
  const loginuserid = localStorage.getItem('user_id');
  const replyUser = replyData.replyuser ?? replyData.user ?? {};
  const membershipBadges = getUserMembershipBadges(replyUser, items);
  useEffect(() => {
    SetStickerSelection(stickerPickItems.toString());
  }, [stickerPickItems]);

  const textRef = useRef(null);

  function converTime(datevalue: any) {
    const date = new Date(datevalue);
    const formattedDate = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
    });
    return formattedDate;
  }

  const modules = {
    toolbar: false,
  };

  const [text, setText] = useState('');
  useEffect(() => {
    setValue('chat_reply_msg', text);
  }, [text]);

  const openSticker = () => {
    SetShowSticker(!showSticker);
  };

  const onClickSticker = (data: any) => {
    let editor = (textRef.current  as any ).getEditor();
    var range = editor.getSelection();
    let position = range ? range.index : editor.getLength()-1;

    // Preserve scroll — see CommentBox.onClickSticker for rationale.
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    var rte = document.getElementById('my-rich-text-editor'); // Replace with the ID of your Rich Text Editor
    rte?.focus({ preventScroll: true });
    var imageSrc = data;
    editor.insertEmbed(position, 'image', imageSrc);
    editor.setSelection(position + 1, 0);

    window.scrollTo(scrollX, scrollY);
    requestAnimationFrame(() => window.scrollTo(scrollX, scrollY));
  }

  function converDate(datevalue: any) {
    const date = new Date(datevalue);
    const formattedDate = date.toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: '2-digit',
    });
    return formattedDate;
  }
  const [Notify, setIsNotify] = useState<any | string>();
  const [RemoveType, setRemoveType] = useState<any | string>('R');
  const onRemove = (ban_chat_id: any) => {
    dispatch<any>(removeUserLoungeWdw({ ban_chat_id, RemoveType })).then(
      (res: any) => {
        window.location.reload();
        // Notify(toast('Comment Removed'));
      }
    );
  };

  const [editbox, SetEditBox] = useState<any | string>(false);
  const showEditBox = () => {
    SetEditBox(!editbox);
  };


  const [formatedMsg, setFormatedMsg] = useState(replyData.chat_reply_msg);

  useEffect(() => {

    var domParser = new DOMParser();
    var doc = domParser.parseFromString(replyData.chat_reply_msg || '', 'text/html');
    var msg = doc.body.innerHTML;
    
    let replacemsg = msg.match(/@(\w+)/g)?.map(match => match.substring(1));
    async function convert()
    {
      for(const val of replacemsg ?? []) {
        if(val.length > 0) {
          let response = await axios.get(GET_BASE_URL + '/api/v1/getUserId?name=' + val)
          if(response.data.data.length > 0) {
            let id = response.data.data[0].id;
            let htmltext = "<a href='/disneyland/user/" + id + "/mypost'>@" + val + "</a>";
            msg = msg.replace('@' + val, htmltext);
          }
        } 
      }
      setFormatedMsg(msg)
    }
    convert();
  }, [replyData.chat_reply_msg]);

  return (
    <>      
      <div className='mid-comm-s mid-comm-s2 mw-comment-reply-wrap'>
        <div className='comm-bo mw-comment-card mw-comment-reply-card d-flex'>
          <div className='small-c mw-comment-avatar'>
            <Link to={`/disneyland/user/${replyUser?.user_id}/mypost`}>
              <img
                src={getMouseWaitUserAvatarUrl(
                  replyUser,
                  GET_BASE_URL_IMAGE +
                    '/disneyland/images/thumbs/' +
                    replyUser.image
                )}
                className='com-imggg'
                alt={`${replyUser?.user_name || 'MouseWaiter'} avatar`}
              />
            </Link>
          </div>
          <div className='comm-c mw-comment-main d-flex'>
            <div className='commentlist mw-comment-message'>
              <div
                dangerouslySetInnerHTML={{
                  __html: formatedMsg
                    .replace('<p>', '<span>')
                    .replace('</p>', '</span>')
                    .replace('<br>', ''),
                }}
              />
            </div>

            <div className='mw-comment-footer mw-comment-reply-footer'>
              <div className='mw-comment-author-stack'>
                <div className='mw-comment-author-row'>
                  <Link
                    className='mw-comment-author-name'
                    to={`/disneyland/user/${replyUser?.user_id}/mypost`}
                  >
                    {replyUser?.user_name}
                  </Link>
                  {membershipBadges.map((badge) => (
                    <span
                      key={badge.key}
                      className={`mw-comment-badge ${badge.className}`}
                      title={badge.title}
                    >
                      {badge.label}
                    </span>
                  ))}
                </div>
                <div className='com-tt mw-comment-stats mw-comment-reply-stats'>
                  <span>{replyUser?.rank}</span>
                  <span>#{replyUser?.position}</span>
                  <span>{converDate(replyData?.chat_reply_date)}</span>
                </div>
              </div>

              <div className='co-l mw-comment-actions mw-comment-reply-actions'>
                <button type='button'>Flag</button>
                  <LikeCommentReply
                    likecount={replyData.no_of_likes}
                    chat_id={replyData.chat_id}
                    comment_id={replyData.chat_reply_id}
                    reply_id={replyData.id}
                    commnet_userid={replyUser.user_id}
                    type={'R'}
                    page={'DL'}
                  />
                {replyUser.user_id == loginuserid ? (
                  <>
                    <button type='button' onClick={showEditBox}>Edit</button>
                    <button type='button' onClick={() => onRemove(replyData.id)}>Delete</button>
                  </>
                ) : (
                  <></>
                )}
                {onReplyToParent && (
                  <button
                    type='button'
                    onClick={() =>
                      onReplyToParent(
                        replyUser?.user_name,
                        replyData.id ?? replyData.reply_id ?? replyData.chat_reply_reply_id,
                        replyData.chat_reply_msg
                      )
                    }
                  >
                    Reply
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <EditBox
          replyData={''}
          id={replyData.id}
          chatId={replyData.chat_id}
          chat_reply_id={replyData.chat_reply_id}
          chat_reply_msg={replyData.chat_reply_msg}
          stickerData={stickerData}
          editbox={editbox}
          type={'WR'}
        />
        {replyComposer}
      </div>
    </>
  );
};
